import React from "react";
import HeroCicle from "../heroCircle";
import { HeroContainer } from "./index.styled";

const Hero = () => {
  return (
    <div className="container" id="aboutAvanegar">
      <HeroContainer>
        <HeroCicle />
      </HeroContainer>
    </div>
  );
};

export default Hero;
